import React from 'react';
import clsx from 'clsx';
import { Square, SquareCheck } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { TaskCard } from './TaskCard';

/**
 * A task of a queue that can also be chosen to work with others: a 44 px box
 * beside the card. The box chooses; the card still opens the task alone.
 *
 * @param {object} props - `TaskCard`'s, plus:
 * @param {boolean} props.selected
 * @param {boolean} [props.selectDisabled] - The batch is full: only the chosen can be let go.
 * @param {() => void} props.onToggle
 * @param {object} [props.selectData] - The box's `data-*` attributes, like the card's `data`.
 * @param {boolean} [props.selectable=true] - Without it, just the card: no box.
 */
export const SelectableTaskCard = ({
  selected,
  selectDisabled = false,
  onToggle,
  selectData = {},
  selectable = true,
  ...card
}) => {
  if (!selectable) return <TaskCard {...card} />;

  return (
    <div className="flex items-start gap-2">
      <Button
        variant={selected ? 'outline' : 'ghost'}
        size="lg"
        iconOnly
        icon={selected ? SquareCheck : Square}
        aria-pressed={selected}
        aria-label={`${selected ? 'Quitar' : 'Elegir'} ${card.title} para pickear junto`}
        disabled={selectDisabled && !selected}
        onClick={onToggle}
        data-testid="task-select"
        {...selectData}
        className="shrink-0"
      />
      <div className={clsx('min-w-0 flex-1 rounded-2xl', selected && 'ring-2 ring-ninja-green')}>
        <TaskCard {...card} />
      </div>
    </div>
  );
};
